export default {
  "name": "NCRefer",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCRefer",
  "label": "参照",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "refName": {
        "title": "标题",
        "description": "标题",
        "type": "string"
      },
      "refType": {
        "title": "参照类型",
        "description": "参照类型",
        "enumNames": [
          "grid",
          "tree",
          "gridTree"
        ],
        "type": "enum",
        "enum": [
          "grid",
          "tree",
          "gridTree"
        ],
        "default": "grid"
      },
      "type": {
        "title": "参照类型",
        "description": "参照类型",
        "enumNames": [
          "popover",
          "dropDown"
        ],
        "type": "enum",
        "enum": [
          "popover",
          "dropDown"
        ],
        "default": "popover"
      },
      "hotDataSize": {
        "title": "历史记录条数",
        "description": "历史记录条数",
        "type": "number",
        "default": 10
      },
      "pageSize": {
        "title": "分页请求数据时每页条数",
        "description": "分页请求数据时每页条数",
        "type": "number",
        "default": 10
      },
      "disabled": {
        "title": "禁用",
        "description": "禁用",
        "type": "boolean",
        "default": false
      },
      "referClassName": {
        "title": "参照最外层的class",
        "description": "参照最外层的class",
        "type": "string"
      },
      "placeholder": {
        "title": "占位文字",
        "description": "占位文字",
        "type": "string"
      },
      "showHistory": {
        "title": "获取焦点时，是否显示历史记录",
        "description": "获取焦点时，是否显示历史记录",
        "type": "boolean",
        "default": true
      },
      "queryGridUrl": {
        "title": "查询表数据的请求url",
        "description": "查询表数据的请求url",
        "type": "string"
      },
      "queryTreeUrl": {
        "title": "查询树数据的请求url",
        "description": "查询树数据的请求url",
        "type": "string"
      },
      "isCacheable": {
        "title": "是否启用数据缓存",
        "description": "是否启用数据缓存",
        "type": "boolean",
        "default": true
      },
      "isMultiSelectedEnabled": {
        "title": "是否多选",
        "description": "是否多选",
        "type": "boolean",
        "default": false
      },
      "maxCacheNum": {
        "title": "缓存条数",
        "description": "缓存条数",
        "type": "number",
        "default": 10
      },
      "autoFocus": {
        "title": "自动获取焦点",
        "description": "自动获取焦点",
        "type": "boolean",
        "default": false
      },
      "onlyLeafCanSelect": {
        "title": "是否只有叶子节点可选",
        "description": "是否只有叶子节点可选",
        "type": "boolean",
        "default": false
      },
      "allowSearchConfig": {
        "title": "是否显示搜索设置",
        "description": "是否显示搜索设置",
        "type": "boolean",
        "default": false
      },
      "allowColumnConfig": {
        "title": "是否显示列设置",
        "description": "是否显示列设置",
        "type": "boolean",
        "default": true
      },
      "fieldDisplayed": {
        "title": "作为display的字段",
        "description": "作为display的字段",
        "type": "string",
        "default": "refname"
      },
      "fieldValued": {
        "title": "作为value的字段",
        "description": "作为value的字段",
        "type": "string",
        "default": "refpk"
      },
      "isShowDisabledData": {
        "title": "是否显示停用数据",
        "description": "是否显示停用数据",
        "type": "boolean",
        "default": true
      },
      "isHasDisabledData": {
        "title": "是否有【显示停用】功能",
        "description": "是否有【显示停用】功能",
        "type": "boolean",
        "default": true
      },
      "isShowUnit": {
        "title": "是否显示业务单元",
        "description": "是否显示业务单元",
        "type": "boolean",
        "default": true
      },
      "checkStrictly": {
        "title": "严格的检查每一条数据",
        "description": "严格的检查每一条数据",
        "type": "boolean",
        "default": false
      },
      "popWindowClassName": {
        "title": "添加到弹出层的class",
        "description": "添加到弹出层的class",
        "type": "string"
      },
      "idKey": {
        "title": "树id对应的key值",
        "description": "树id对应的key值",
        "type": "string",
        "default": "refpk"
      },
      "pidKey": {
        "title": "树pid对应的key值",
        "description": "树pid对应的key值",
        "type": "string",
        "default": "pid"
      },
      "rowKey": {
        "title": "表格行对应的key值",
        "description": "表格行对应的key值",
        "type": "string",
        "default": "refpk"
      },
      "isShowUsual": {
        "title": "树表参照是否显示【常用】",
        "description": "树表参照是否显示【常用】",
        "type": "boolean",
        "default": false
      },
      "isShowTableSearch": {
        "title": "显示表格区的搜索框",
        "description": "显示表格区的搜索框",
        "type": "boolean",
        "default": true
      },
      "isShowTreeSearch": {
        "title": "显示树区的搜索框",
        "description": "显示树区的搜索框",
        "type": "boolean",
        "default": true
      },
      "showTitle": {
        "title": "鼠标悬停时是否显示title",
        "description": "鼠标悬停时是否显示title",
        "type": "boolean",
        "default": true
      },
      "isRunWithChildren": {
        "title": "是否启用【执行时包含下级】功能",
        "description": "是否启用【执行时包含下级】功能",
        "type": "boolean",
        "default": false
      },
      "isAlwaysEmitOnChange": {
        "title": "是否始终触发onChange事件",
        "description": "是否始终触发onChange事件",
        "type": "boolean",
        "default": false
      },
      "tabIndex": {
        "title": "参照的tabindex",
        "description": "参照的tabindex",
        "type": "number",
        "default": 0
      },
      "unitValueIsNeeded": {
        "title": "只有选业务单元才会发请求",
        "description": "只有选业务单元才会发请求",
        "type": "boolean",
        "default": false
      },
      "baseTabIndex": {
        "title": "tabIndex基于此值往上加",
        "description": "tabIndex基于此值往上加",
        "type": "number",
        "default": 0
      },
      "needFocusOnClose": {
        "title": "关闭后是否需要获取焦点",
        "description": "关闭后是否需要获取焦点",
        "type": "boolean",
        "default": true
      },
      "dropDownPlacement": {
        "title": "dropdown组件的placement属性",
        "description": "dropdown组件的placement属性",
        "type": "string",
        "default": "bottomLeft"
      },
      "maxChoice": {
        "title": "最多选择的数据条数",
        "description": "最多选择的数据条数",
        "type": "number",
        "default": 1000
      },
      "async": {
        "title": "请求是否异步",
        "description": "请求是否异步",
        "type": "boolean",
        "default": true
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}